<template>
  <div class="audit-page">
    <div
      v-show="!showFilterModal"
      class="repeat-index"
    >
      <header-back
        :title="title"
        @back="onClickBack"
      />
      <div class="content">
        <div class="blank">
          <img
            src="@/assets/images/sousuo.png"
            alt="repeatAlt"
          >
          <p class="text">
            {{ $t('message["96"]') }}
          </p>
        </div>
        <ul
          v-if="searchConfig.options"
          class="search-config"
        >
          <li
            v-for="item in searchConfig.options"
            :key="item.fieldkey"
            @click="handleChange(item.fieldkey)"
          >
            {{ item.fieldname }}
          </li>
        </ul>
      </div>
    </div>
    <my-list
      :visible.sync="showFilterModal"
      :checkrepeatfieldkey="searchConfig.key"
      class="list-wrap"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import HeaderBack from '@/components/mobile/HeaderBack.vue'
import MyList from './List'

export default {
  components: {
    HeaderBack,
    MyList
  },
  data () {
    return {
      title: this.$t('message["1355"]'),
      showFilterModal: false
    }
  },
  computed: {
    ...mapState('inquery/repeatData', [
      'searchConfig'
    ]),
    repeatfieldkey () {
      return this.$route.query.repeatfieldkey || ''
    },
    repeatfieldvalue () {
      return this.$route.query.repeatfieldvalue || ''
    },
    repeatAlt () {
      return this.$t('message["94"]')
    }
  },
  created () {
    this.getSearchConfig()
  },
  methods: {
    ...mapActions('inquery/repeatData', ['fetchSearchConfig', 'setSearchConfig']),
    onClickBack () {
      this.$router.push({
        name: 'ProjectIndex'
      })
    },
    async getSearchConfig (params) {
      const chain = await this.fetchSearchConfig({
        repeatfieldkey: this.repeatfieldkey,
        repeatfieldvalue: this.repeatfieldvalue
      })
      chain
        .params({ ...params })
        .onNetSuccess(res => {
          document.title = this.$t('message["1355"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        })
        .fetch()
    },
    handleChange (val) {
      this.searchConfig.key = val
      for (let item of this.searchConfig.options) {
        if (item.fieldkey === this.searchConfig.key) {
          this.searchConfig.placeholder = `${this.$t('message["751"]')} ${item.fieldname}`
        }
      }
      this.setSearchConfig(this.searchConfig)
      this.openFilter()
    },
    openFilter () {
      this.showFilterModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-page {
  height: 100%;
  overflow: hidden;
}
.search-config {
  margin-top: 27px;
  padding: 0 38px;
  text-align: center;
  li {
    display: inline-block;
    margin: 10px 0;
    padding: 0 20px;
    text-align: center;
    font-size: 16px;
    color: $primary-color;
    border-right: solid 1px #d8d8d8;
    /* &:nth-child(3n) {
      border: none;
    } */
    &:last-child {
      border: none;
    }
  }
}
.blank {
  img {
    width: 100px;
    margin: 0 0 18px;
  }
  .text {
    color: #999;
    font-size: 16px;
  }
}
.list-wrap {
  height: 100%;
  overflow: hidden;
}
</style>
